import { render, staticRenderFns } from "./TheVisaDetails.vue?vue&type=template&id=323262ee&"
import script from "./TheVisaDetails.vue?vue&type=script&lang=js&"
export * from "./TheVisaDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports